/**
 * House関連のStoreで使用するStateをここで定義する
 *
 * Copyright (c) 2018-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const AuditState = Record({
  id: null,
  column_name: '',
  old_value: '',
  new_value: '',
  username: '',
  updated_at: null
})

export { AuditState }
